import { apiSlice } from '@/store/api/apiSlice';

interface PlanetPadaChange {
  nakshatra: string;
  pada: number;
  timestamp: string;
}

export interface PlanetPadaResponse {
  planetName: string;
  pada: PlanetPadaChange[];
}

export const planetPadaTransitApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPlanetPadaTransit: builder.query<PlanetPadaResponse[], void>({
      query: () => ({
        url: '/transits/planet-pada-gochar',
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetPlanetPadaTransitQuery } = planetPadaTransitApi;
